var map = {
	"./Approved.svg": 3846,
	"./AwaitingParts.svg": 3847,
	"./Closed.svg": 3848,
	"./Completed.svg": 3849,
	"./Excel.svg": 3850,
	"./Exportall_grey.svg": 3851,
	"./Exportall_grey_circle.svg": 3852,
	"./InProgress.svg": 3853,
	"./New.svg": 3854,
	"./View_Pic_Grey.svg": 3855,
	"./accident.svg": 3856,
	"./account.svg": 3857,
	"./addOrange.svg": 3858,
	"./addUser.svg": 3859,
	"./addVehicle.svg": 3860,
	"./address.svg": 3861,
	"./alert.svg": 3862,
	"./all_active.svg": 3863,
	"./all_active_es.svg": 3864,
	"./arrow-down.svg": 3865,
	"./arrow-up.svg": 3866,
	"./arrowRight.svg": 3867,
	"./awaiting_parts_grey.svg": 3868,
	"./awaiting_parts_orange.svg": 3869,
	"./back-btn.svg": 3870,
	"./back-button-grey.svg": 3871,
	"./backButton.svg": 3872,
	"./bills_of_landing_active.svg": 3873,
	"./bills_of_landing_active_es.svg": 3874,
	"./bobTail.svg": 3875,
	"./book-solid.svg": 3876,
	"./boxTruck.svg": 3877,
	"./calanderIcon.svg": 3878,
	"./cameraSelected.svg": 3879,
	"./camera_selected.svg": 3880,
	"./chat-icon.svg": 3881,
	"./circle-Exportall_grey.svg": 3882,
	"./circle-export.svg": 3883,
	"./circle-exportUser.svg": 3884,
	"./circle-import.svg": 3885,
	"./circle-importUser.svg": 3886,
	"./circle-viewall.svg": 3887,
	"./clearAll.svg": 3888,
	"./close-popup.svg": 3889,
	"./closeMap.svg": 3890,
	"./closed-Orange.svg": 3891,
	"./closed-grey.svg": 3892,
	"./clusterIcon.svg": 3893,
	"./communication_records_active.svg": 3894,
	"./communication_records_active_es.svg": 3895,
	"./company.svg": 3896,
	"./companyIcon.svg": 3897,
	"./complete-Orange.svg": 3898,
	"./complete-grey.svg": 3899,
	"./csa.svg": 3900,
	"./csaSnapshot.svg": 3901,
	"./dailyDocuments.svg": 3902,
	"./dashboard.svg": 3903,
	"./dashboardIcon.svg": 3904,
	"./date.svg": 3905,
	"./delete.svg": 3906,
	"./deleteCircle.svg": 3907,
	"./delivery_receipts_active.svg": 3908,
	"./delivery_receipts_active_es.svg": 3909,
	"./departments.svg": 3910,
	"./departmetEdit.svg": 3911,
	"./developer.svg": 3912,
	"./direction.svg": 3913,
	"./dispatch_records_active.svg": 3914,
	"./dispatch_records_active_es.svg": 3915,
	"./document.svg": 3916,
	"./documents.svg": 3917,
	"./dot.svg": 3918,
	"./dotAudit.svg": 3919,
	"./dotauditIcon.svg": 3920,
	"./downarrowIcon.svg": 3921,
	"./download.svg": 3922,
	"./downloadCenter.svg": 3923,
	"./downloadCenterMenu.svg": 3924,
	"./driver-behaviour.svg": 3925,
	"./driver.svg": 3926,
	"./dryVan.svg": 3927,
	"./dtc.svg": 3928,
	"./dualCam.svg": 3929,
	"./dump.svg": 3930,
	"./edit.svg": 3931,
	"./editLogIcon.svg": 3932,
	"./editSvg.svg": 3933,
	"./en.svg": 3934,
	"./es.svg": 3935,
	"./excelNew.svg": 3936,
	"./export-grey.svg": 3937,
	"./export.svg": 3938,
	"./exportUser.svg": 3939,
	"./feedback.svg": 3940,
	"./file-pdf-regular.svg": 3941,
	"./filter.svg": 3942,
	"./flatBed.svg": 3943,
	"./fleet.svg": 3944,
	"./fleetCompanies.svg": 3945,
	"./fleetdriverIcon.svg": 3946,
	"./fleetvehiclesIcon.svg": 3947,
	"./fletBed.svg": 3948,
	"./fr.svg": 3949,
	"./fuel.svg": 3950,
	"./full.svg": 3951,
	"./hamburger.svg": 3952,
	"./help-icon.svg": 3953,
	"./historyLogs.svg": 3954,
	"./icon-delete.svg": 3955,
	"./icon-export.svg": 3956,
	"./icon-menu-logs.svg": 3957,
	"./ifta.svg": 3958,
	"./import.svg": 3959,
	"./importUser.svg": 3960,
	"./in_progress_grey.svg": 3961,
	"./in_progress_orange.svg": 3962,
	"./infoTruck.svg": 3963,
	"./inspection-dvir.svg": 3964,
	"./inspection.svg": 3965,
	"./key.svg": 3966,
	"./leftArrow.svg": 3967,
	"./location.svg": 3968,
	"./locationMap.svg": 3969,
	"./log.svg": 3970,
	"./logEdit.svg": 3971,
	"./logHistory.svg": 3972,
	"./logoutIcon.svg": 3973,
	"./logs.svg": 3974,
	"./logsIcon.svg": 3975,
	"./mack.svg": 3976,
	"./mail.svg": 3977,
	"./main_camera.svg": 3978,
	"./mappinPopup.svg": 3979,
	"./menu_companies.svg": 3980,
	"./menu_dailyLog.svg": 3981,
	"./menu_reports.svg": 3982,
	"./menu_reseller.svg": 3983,
	"./menu_vehicle.svg": 3984,
	"./messageSender.svg": 3985,
	"./messaging.svg": 3986,
	"./new_login.svg": 3987,
	"./ninePin.svg": 3988,
	"./nonEdit.svg": 3989,
	"./notFull.svg": 3990,
	"./not_started_grey.svg": 3991,
	"./not_started_orange.svg": 3992,
	"./otherTrailer.svg": 3993,
	"./otherTruck.svg": 3994,
	"./other_documents_active.svg": 3995,
	"./other_documents_active_es.svg": 3996,
	"./overview.svg": 3997,
	"./page-first.svg": 3998,
	"./page-last.svg": 3999,
	"./page-next.svg": 4000,
	"./page-prev.svg": 4001,
	"./phone.svg": 4002,
	"./pickup.svg": 4003,
	"./pneumaticTrailer.svg": 4004,
	"./policy.svg": 4005,
	"./popupClose.svg": 4006,
	"./popupConfirm.svg": 4007,
	"./popupDelete.svg": 4008,
	"./privatePassenger.svg": 4009,
	"./qbdii.svg": 4010,
	"./receipts_active.svg": 4011,
	"./receipts_active_es.svg": 4012,
	"./reeferTrailer.svg": 4013,
	"./refreshCircle.svg": 4014,
	"./renewal.svg": 4015,
	"./repair.svg": 4016,
	"./reportIcon.svg": 4017,
	"./reports.svg": 4018,
	"./save-regular.svg": 4019,
	"./scoreCard.svg": 4020,
	"./searchGrey.svg": 4021,
	"./selectedConnection.svg": 4022,
	"./share.svg": 4023,
	"./sixPin.svg": 4024,
	"./sort.svg": 4025,
	"./speedometer.svg": 4026,
	"./spotlightGreen.svg": 4027,
	"./spotlightGrey.svg": 4028,
	"./spotlightRed.svg": 4029,
	"./straightTruck.svg": 4030,
	"./supportIcon.svg": 4031,
	"./switch.svg": 4032,
	"./tankerTrailer.svg": 4033,
	"./tick.svg": 4034,
	"./time.svg": 4035,
	"./timePicker.svg": 4036,
	"./toggle-off.svg": 4037,
	"./toggle-on.svg": 4038,
	"./tools.svg": 4039,
	"./tractorDayCab.svg": 4040,
	"./tractorSleeper.svg": 4041,
	"./undelete.svg": 4042,
	"./unsaved.svg": 4043,
	"./update.svg": 4044,
	"./upload.svg": 4045,
	"./usdot.svg": 4046,
	"./user.svg": 4047,
	"./userprofileIcon.svg": 4048,
	"./users.svg": 4049,
	"./vacuumTrailer.svg": 4050,
	"./vacuumTruck.svg": 4051,
	"./van.svg": 4052,
	"./vehicle-behaviour.svg": 4053,
	"./vehicle.svg": 4054,
	"./vehicleIcon.svg": 4055,
	"./viewArrow.svg": 4056,
	"./viewDocument.svg": 4057,
	"./viewReports.svg": 4058,
	"./viewStatus.svg": 4059,
	"./viewallMap.svg": 4060,
	"./violation.svg": 4061,
	"./volvo.svg": 4062,
	"./weigh_tickets_active.svg": 4063,
	"./weigh_tickets_active_es.svg": 4064,
	"./whitecheck_new.svg": 4065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3845;